export class CreditReportException extends Error {
  public message: string;
  private readonly code: string;

  public constructor(code: string) {
    super();
    this.code = code;
    this.message = this.getErrorMessage();
    Object.setPrototypeOf(this, CreditReportException.prototype);
  }

  private getErrorMessage(): string {
    const error_messages: any = {
      "1000": "El reporte ya está completado",
      "1001": "Reporte sin historial crediticio",
      "1002": "Reporte deshabilitado o inválido",
      "1003": "Reporte bloqueado por Buró de Crédito",
      "1004": "El reporte no está en estado de validación de NIP",
      "1005": "El reporte no está en estado de captura de datos",
      "1006": "La investigación ya está completada",
      "1007": "El reporte no está en estado de reporte largo",
      "1008": "El reporte está siendo procesado",
      "1009": "El NIP es incorrecto.",
      "1010": "El NIP no ha sido confirmado",
      "1011": "El NIP no es válido",
      "1012": "El NIP ya ha sido confirmado",
      "1013": "El NIP ha expirado, porfavor reenvia un nuevo NIP",
      "1014": "El NIP tiene demasiados reenvíos, crea un reporte nuevo",
      "1015": "El reporte ha sido invalidado",
      "1016": "Las cuotas no son suficientes para completar este reporte",
      "1017": "Reporte con coincidencias ambiguas por Buró de Crédito",
      "1018":
        "El historial crediticio es extremadamente largo, por favor contacta al equipo de soporte para poder ayudarte.",
      // errors fields
      "1101": "El campo 'email' tiene un formato incorrecto.",
      "1102": "El campo 'Teléfono' tiene un formato incorrecto.",
      // "1103": "El campo 'enviarNIPPor' tiene un formato incorrecto.",
      "1104": "El campo 'Nombre(s)' tiene un formato incorrecto.",
      "1105": "El campo 'Apellido Paterno' tiene un formato incorrecto.",
      "1106": "El campo 'Apellido Materno' tiene un formato incorrecto.",
      "1107": "El campo 'Fecha de Naciemiento' tiene un formato incorrecto.",
      "1108": "El campo 'RFC' tiene un formato incorrecto.",
      "1109": "El campo 'CURP' tiene un formato incorrecto.",
      // "1110": "El campo 'nacionalidad' tiene un formato incorrecto.",
      "1111": "La 'dirección' tiene un formato incorrecto.",
      "1112": "El campo 'Colonia' tiene un formato incorrecto.",
      "1113": "El campo 'Municipio' tiene un formato incorrecto.",
      "1114": "El campo 'Estado' tiene un formato incorrecto.",
      // "1115": "El campo 'país' tiene un formato incorrecto.",
      "1116": "El campo 'Código Postal' tiene un formato incorrecto.",
      "1117": "El campo 'Ciudad' tiene un formato incorrecto.",
      "1118": "El campo 'Razón Social' tiene un formato incorrecto.",
      "2000": "La investigación ha sido invalidada",
      // general error
      "6050": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
    };
    return error_messages[this.code] || "Error desconocido";
  }
}
